{
  "files.title": "الملفات",
  "files.task.title": "المرفقات",
  "files.task.empty": "لا توجد ملفات على هذه المهمة بعد.",
  "files.loadError": "تعذّر تحميل الملفات.",
  "files.loadMore": "عرض المزيد من الملفات",
  "files.loadingMore": "جارٍ التحميل…",
  "files.search": "ابحث في الملفات",
  "files.pastedName": "لقطة شاشة",
  "files.inComment": "مرفق بتعليق",
  "files.drop.title": "أفلت الملفات هنا، أو الصق لقطة شاشة، أو تصفّح جهازك",
  "files.drop.release": "أفلت الملفات لبدء الرفع",
  "files.drop.hint": "صور أو PDF أو ملفات Office أو نصوص أو MP4 أو ZIP، حتى {size} ميغابايت للملف",
  "files.upload.button": "رفع ملفات",
  "files.upload.listLabel": "الملفات قيد الرفع",
  "files.upload.waiting": "في انتظار الرفع…",
  "files.upload.progress": "جارٍ الرفع… {percent}",
  "files.upload.progressLabel": "تقدّم رفع {name}",
  "files.upload.cancelled": "أُلغي الرفع.",
  "files.upload.cancel": "إلغاء رفع {name}",
  "files.upload.dismiss": "إخفاء {name}",
  "files.problem.tooLarge": "هذا الملف كبير جدًا. الحد الأقصى للملف {size} ميغابايت.",
  "files.problem.notAllowed": "هذا النوع من الملفات غير مسموح. استخدم صورة أو PDF أو ملف Office أو نصًا أو MP4 أو ZIP.",
  "files.problem.mismatch": "محتوى هذا الملف لا يطابق نوعه. احفظه مجددًا بالصيغة الصحيحة ثم أعد المحاولة.",
  "files.problem.empty": "هذا الملف فارغ.",
  "files.problem.network": "انقطع الاتصال. تحقّق من اتصالك بالإنترنت وحاول مجددًا.",
  "files.problem.forbidden": "لا يمكنك إضافة الملفات أو تغييرها هنا.",
  "files.problem.gone": "هذا الملف لم يعد موجودًا.",
  "files.problem.generic": "حدث خطأ ما. حاول مجددًا.",
  "files.actions.label": "إجراءات {name}",
  "files.actions.openNamed": "فتح {name}",
  "files.actions.openInTab": "فتح في علامة تبويب جديدة",
  "files.actions.download": "تنزيل",
  "files.actions.remove": "حذف",
  "files.remove.title": "حذف هذا الملف؟",
  "files.remove.body": "سيختفي {name} من المهمة والمشروع لدى الجميع.",
  "files.remove.pending": "جارٍ الحذف…",
  "files.versions.title": "سجل الإصدارات",
  "files.versions.number": "إصدار {number}",
  "files.versions.open": "{count, plural, zero {لا إصدارات} one {إصدار واحد} two {إصداران} few {# إصدارات} many {# إصدارًا} other {# إصدار}}: عرض السجل",
  "files.versions.upload": "رفع إصدار جديد",
  "files.versions.uploaded": "أصبح {name} الإصدار {number}.",
  "files.versions.uploading": "إصدار جديد… {percent}",
  "files.versions.loadError": "تعذّر تحميل الإصدارات.",
  "files.lightbox.position": "{position} من {total}",
  "files.lightbox.previous": "الصورة السابقة",
  "files.lightbox.next": "الصورة التالية",
  "files.groups.project": "ملفات المشروع",
  "files.empty.title": "لا توجد ملفات بعد",
  "files.empty.body": "أفلت الملفات هنا أو ارفعها. وستظهر هنا أيضًا الملفات المرفقة بالمهام.",
  "files.empty.bodyReadOnly": "ستظهر هنا الملفات المرفقة بالمشروع وبمهامه.",
  "files.empty.filteredTitle": "لا توجد ملفات مطابقة",
  "files.empty.filteredBody": "جرّب اسمًا آخر أو نوع ملف مختلفًا.",
  "files.filter.label": "نوع الملف",
  "files.filter.all": "الكل",
  "files.filter.image": "الصور",
  "files.filter.document": "المستندات",
  "files.filter.video": "الفيديو",
  "files.filter.archive": "الملفات المضغوطة",
  "files.filter.clear": "مسح عوامل التصفية",
  "files.kind.image": "صورة",
  "files.kind.vector": "صورة متجهة (SVG)",
  "files.kind.pdf": "مستند PDF",
  "files.kind.document": "مستند Word",
  "files.kind.spreadsheet": "جدول Excel",
  "files.kind.slides": "عرض PowerPoint",
  "files.kind.table": "جدول CSV",
  "files.kind.text": "ملف نصي",
  "files.kind.video": "فيديو",
  "files.kind.archive": "ملف ZIP مضغوط",
  "files.kind.file": "ملف"
}
